import { render, staticRenderFns } from "./ExpandMenu.vue?vue&type=template&id=ac205958&scoped=true&lang=pug"
import script from "./ExpandMenu.vue?vue&type=script&lang=js"
export * from "./ExpandMenu.vue?vue&type=script&lang=js"
import style0 from "./ExpandMenu.vue?vue&type=style&index=0&id=ac205958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac205958",
  null
  
)

export default component.exports